import { set, uniq, concat, get, isNumber, map, reduce, findIndex, cloneDeep, clone, includes, sortBy } from 'lodash'
import moment from 'moment'

export default {

  setActive (state, key) {

    if (state.list[key].recentTransactions.items.length > 0) {
      state.list[key].recentTransactions.toUpdateOpt = false
    }
    state.activeTabModel = key
  },

  setInfoTab (state, key) {
    state.list[state.activeTabModel].infoTab = key
  },

  setGameHistory (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'gameHistory.options.page', 1)
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'gameHistory.items', (data.items ? data.items : data))
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'gameHistory.totalRows', (data.totalRows ? data.totalRows : []))
  },
  setSportHistory (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'sportHistory.options.page', 1)
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'sportHistory.items', (data.items ? data.items : data))
  },

  setAutomaticKYC (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'kyc.automatic.items', (data.items ? data.items : data))
  },

  setFinance (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'finance.items', (data.items ? data.items : data))
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'finance.totalItems', (data.total ? data.total : 0))
  },

  setStats (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'stats.items', (data.items ? data.items : data))
  },

  setTasks (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'tasks.items', (data.items ? data.items : data))
  },

  setRecentTransactions (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'recentTransactions.items', data.data)
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'recentTransactions.total', data.total)
  },

  setBonuses (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'bonus.items', (data.items ? data.items : data))
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'bonus.initItems', cloneDeep((data.items ? data.items : data)))
  },

  setPackages (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'packages.items', (data.items ? data.items : data))
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'packages.games', (data.games ? data.games : []))
  },

  setShop (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'shop.items', (data.items ? data.items : data))
  },

  setBenefits (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'benefits.items', (data.items ? data.items : data))
  },

  setComments (state, data) {
    let index = findIndex(state.list, { account_id: data.account.account_id })
    set(state.list[index].comments.items, `${data.type}`, (data.items || []))
  },

  setDocuments (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'kyc.documents.items', data.items)
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'kyc.documents.summary', data.summary)
  },

  setKYC (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'kyc.info', data.kyc)
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'kyc.data', data.data)
  },

  setOAuth (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'oauth.data', data.items)
  },

  setTrueplay (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'trueplay.data', data.data)
  },

  setIovation (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'iovation.items', data.items)
  },

  setLimits (state, data) {
    set(state.list[isNumber(data.index) ? data.index : state.activeTabModel], 'limits.items', data.items)
  },

  setLoginHistory (state, items) {
    set(state.list[state.activeTabModel], `loginHistory.items`, (items || []))
  },

  setPaymethodsWhitelist (state, items) {
    set(state.list[state.activeTabModel], `paymethods.items`, (items || []))
    set(state.list[state.activeTabModel], `paymethods.items`, uniq(concat(get(state.list[state.activeTabModel], `paymethods.items`, []), map(get(state.list[state.activeTabModel], `account.data.whitelisted`, []), (o) => ({ name: o })))))
  },

  sortPaymethodsWhitelist (state) {
    let sorted = sortBy(get(state.list[state.activeTabModel], `paymethods.items`, []), (o) => !includes(get(state.list[state.activeTabModel], `account.data.whitelisted`, []), o.name))
    set(state.list[state.activeTabModel], `paymethods.items`, sorted)
  },

  setDuplicates (state, data) {
    set(state.list[state.activeTabModel], `duplicates.items`, (data.data || []))
    set(state.list[state.activeTabModel], `duplicates.totalItems`, (data.total || 0))

    if (get(state.list[state.activeTabModel], `duplicates.login_list`, []).length == 0) {
      let loginList = reduce(data.data.slice(0, 25), (r, i) => {
        r[i.account_id] = (i.account.prefix + i.account.login).toUpperCase()
        r[i.double_id] = (i.double.prefix + i.double.login).toUpperCase()
        return r
      }, {})

      set(state.list[state.activeTabModel], `duplicates.login_list`, (Object.values(loginList) || []))
    }
  },

  refresh (state, account) {
    let index = findIndex(state.list, { account_id: account.account_id })

    state.list[index].account = cloneDeep(account)
    state.list[index].initAccount = cloneDeep(account)

  },

  balance_refresh (state, account) {
    let index = findIndex(state.list, { account_id: account.account_id })
    if (!state.list[index]) return

    state.list[index].account.balance = account.balance
    state.list[index].account.bonus = account.bonus
    state.list[index].account.bonus_sport = account.bonus_sport

    state.list[index].initAccount.balance = account.balance
    state.list[index].initAccount.bonus = account.bonus
    state.list[index].initAccount.bonus_sport = account.bonus_sport

  },

  setDefaultCommentsTab (state, params) {
    if (params.tabIndex) {
      state.default.comments.tab = params.tabIndex
    } else if (params.role) {
      state.default.comments.tab = state.default.comments.roleMap[params.role] || 0
    }
  },

  add (state, account) {
    state.list.push({
      loading: false,
      account,
      initAccount: cloneDeep(account),
      account_id: account.account_id,
      infoTab: 'dashboard',
      bonusTab: 'bonus',
      total: {
        deposits: 0,
        withdrawals: 0,
        lockedForWithdrawals: 0,
        bonuses: 0,
        bets: 0,
        ggr: 0,
        ngr: 0
      },
      recentTransactions: {
        toUpdateOpt: true,
        options: {},
        total: 0,
        items: [],
        loading: false,
      },
      iovation: {
        loading: false,
        items: []
      },
      limits: {
        loading: false,
        items: []
      },
      loginHistory: {
        loading: false,
        items: []
      },
      duplicates: {
        loading: false,
        loginList: [],
        items: [],
        tableOptions: {
          'sortBy': [ 'created' ],
          'sortDesc': [ true ],
        },
      },
      paymethods: {
        loading: false,
        items: []
      },
      comments: {
        loading: true,
        tab: clone(state.default.comments.tab) || 0,
        items: {
          communication: [],
          ticket: [],
          kyc: [],
          vip: [],
        }
      },
      oauth: {
        loading: false,
        data: {},
      },
      trueplay: {
        loading: false,
        data: null,
      },
      tasks: {
        loading: false,
        items: []
      },
      kyc: {
        loading: false,
        info: {},
        data: {},

        documents: {
          type: null,
          loading: false,
          items: [],
          summary: [],

          pagination: {
            page: 1,
            perpage: 50
          },
        },
        automatic: {
          loading: false,
          loginList: [],
          items: []
        },

      },
      finance: {
        items: [],
        loading: false,
        tableOptions: {
          'sortBy': [ 'created' ],
          'sortDesc': [ true ],
        },
        totalItems: 0,
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        fromTime: '00:00:00',
        toTime: '23:59:59',
        filters: {
          status: { initList: [ 'pending', 'complete', 'cancel', 'decline', ], data: [], type: 'select' },
          type: {
            initList: [ 'deposit', 'withdraw', 'bonus_deposit', 'bonus_withdraw', 'bonus_release' ],
            data: [],
            type: 'select'
          },
          paymethod: { data: [], type: 'select' },
          paysystem: { data: [], type: 'select' },
          transaction_id: { data: [], type: 'text' },
        },
      },
      bonus: {
        items: [],
        initItems: [],
        loading: false,
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        options: {
          itemKey: 'bonus_id',
          expanded: [],
          showExpand: true
        },
        filters: {
          status: { data: [], type: 'select' },
          type: { data: [], type: 'select' },
          bonus_id: { data: [], type: 'text', style: { maxWidth: '50px' } },
          name: { data: [], type: 'text' },
          description: { data: [], type: 'text' },
        },
      },
      shop: {
        items: [],
        loading: false,
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        filters: {
          price: { data: [], type: 'text' },
          transaction_id: { data: [], type: 'text' },
          type: { data: [], type: 'select' },
          categories: { data: [], type: 'text' },
          productName: { data: [], type: 'text' },
          amount: { data: [], type: 'text' },
        },
      },
      packages: {
        items: [],
        games: [],
        options: {
          itemKey: 'package_id',
          expanded: [],
          showExpand: true
        },
        loading: false,
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        filters: {
          package_id: { data: [], type: 'text', style: { maxWidth: '50px' } },
          login: { data: [], type: 'text' },
          currency: { data: [], type: 'select', style: { maxWidth: '100px' } },
          manual_check: { data: [], type: 'select', style: { maxWidth: '50px' } },
          status: { data: [], type: 'select', style: { maxWidth: '150px' } },
        },
      },
      benefits: {
        items: [],
        loading: false,
        filters: {
          benefit_id: { data: [], type: 'text', style: { maxWidth: '50px' } },
          name: { data: [], type: 'text' },
          type: { data: [], type: 'select', style: { maxWidth: '100px' } },
          trigger: { data: [], type: 'select', style: { maxWidth: '100px' } },
        },
      },
      stats: {
        items: [],
        initItems: [],
        loading: false,
        type: 'day',
        current_type: 'day',
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        filters: {
          // status: { data: [], type: 'select' },
          // type: { data: [], type: 'select' },
          // bonus_id: { data: [], type: 'text', style: { maxWidth: '50px' } },
          // name: { data: [], type: 'text' },
          // description: { data: [], type: 'text' },
        },
      },
      gameHistory: {
        items: [],
        totalRows: [],
        options: {},
        loading: false,
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        fromTime: '00:00:00',
        toTime: '23:59:59',
        filters: {
          id: { data: [], type: 'text' },
          parent_id: { data: [], type: 'text' },
          brand: { data: [], type: 'select' },
          game_name: { data: [], type: 'autocomplete' },
          action: { data: [], type: 'select' },
          bonus: { data: [], type: 'text', valueType: 'number' },
          amount: { data: [], type: 'text', valueType: 'number' },
        }
      },
      totalOpenBets: {
        amount: 0,
        loading: false,
      },
      sportHistory: {
        items: [],
        totalRows: [],
        options: {},
        loading: false,
        from: moment().format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD'),
        fromTime: '00:00:00',
        toTime: '23:59:59',
        filters: {
          id: { data: [], type: 'text' },
          parent_id: { data: [], type: 'text' },
          action: { data: [], type: 'select' },
        }
      },
    })
  },

  remove (state, account) {
    let index = state.list.indexOf(account)
    state.list.splice(index, 1)
  },

  removeAll (state) {
    state.list = {}
    state.active = false
  }

}
